import { isWithinInterval } from 'date-fns'
import { zonedTimeToUtc } from 'date-fns-tz'
import { TimeBlock } from '../../types'

interface WorkingHours {
  endTime: string
  startTime: string
}

interface Props {
  blocks: TimeBlock[]
  timeZone: string
  workingHours?: WorkingHours
}

const DEFAULT_WORK_HOURS: WorkingHours = {
  startTime: '05:00:00',
  endTime: '22:00:00',
}

const makeFormat = (timeZone: string) => Intl.DateTimeFormat('en-us', { timeZone, year: 'numeric', month: '2-digit', day: '2-digit' })

const omitNonWorkingTimeBlocks = ({ blocks, timeZone, workingHours = DEFAULT_WORK_HOURS }: Props): TimeBlock[] => {
  const { startTime, endTime } = workingHours
  const formatter = makeFormat(timeZone)

  const toZonedDateWithTime = (date: Date, timePart: string) => {
    const { year, month, day } = formatter.formatToParts(date).reduce<Record<Intl.DateTimeFormatPartTypes, string>>(
      (acc, { type, value }) => ({
        ...acc,
        [type]: value,
      }),
      {} as Record<Intl.DateTimeFormatPartTypes, string>
    )

    return zonedTimeToUtc(`${year}-${month}-${day} ${timePart}`, timeZone)
  }

  const isDuringWorkHours = ({ date_end, date_start }: TimeBlock) => {
    const startOfWorkHours = toZonedDateWithTime(date_start, startTime)
    const endOfWorkHours = toZonedDateWithTime(date_start, endTime)
    const interval = { start: startOfWorkHours, end: endOfWorkHours }
    const isStartDateDuringWorkHours = isWithinInterval(date_start, interval)
    const isEndDateDuringWorkHours = isWithinInterval(date_end, interval)

    return isStartDateDuringWorkHours && isEndDateDuringWorkHours
  }

  const filtered = blocks.filter(isDuringWorkHours)

  return filtered
}

export { omitNonWorkingTimeBlocks }
